"use strict";

var moduleName = "promo";

module.exports = function () {
	$(".jsPromo").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);



		//
		// Промо блок на главной странице
		//

		$(".jsPromoBtnShowMore").on("click", function(e) {
			e.preventDefault();

			$(".jsPromoListItem").show(200).css("display", "inline-block");
			$(".jsPromoListItemBigEmpty").hide(200);
			$(this).hide(200);
		});

		$(window).resize(function() {
			var width = window.innerWidth;

			if (width > 970) {
				$(".jsPromoListItemBigEmpty").show(200);
			}
		});

		$(window).resize(function() {
			var width = window.innerWidth;

			if (width < 970) {
				$(".jsPromoListItemBigEmpty").hide(200);
			}
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/promoInit.js
 **/